export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fe1ad31083d3f6747dbf6a7435c22e2c12f7e3a8f&name=fetchTypeahead!'